import React, { useState } from 'react';
import { StepContainer, StepNavigation, ChoiceButtons } from '../components';
import { StepProps, useFormContext, FormData } from '../context';
import { useFormValidation } from '../hooks';

export const Step17_Cartao: React.FC<StepProps> = ({ onNext, onPrevious, isLoading }) => {
  const { data, updateField } = useFormContext();
  const [errors, setErrors] = useState<Record<string, string>>({});

  const handleNext = () => {
    const newErrors: Record<string, string> = {};

    if (!data.creditCard) newErrors.creditCard = 'Campo obrigatório';

    if (Object.keys(newErrors).length > 0) {
      setErrors(newErrors);
      return;
    }

    onNext({ creditCard: data.creditCard as 'Sim' | 'Não' });
  };

  const handleFieldChange = (fieldName: keyof FormData, value: string) => {
    updateField(fieldName, value);
    if (errors[fieldName]) {
      setErrors(prev => {
        const newErrors = { ...prev };
        delete newErrors[fieldName];
        return newErrors;
      });
    }
  };

  return (
    <StepContainer title="">
      <div className="mb-6">
        <p className="font-semibold mb-2">💳 Você possui cartão de crédito?</p>
        <p className="text-muted-foreground text-sm mb-4">
          Essa informação ajuda a entender melhor sua situação financeira e potencial de consumo.
        </p>
      </div>
      <div>
        <ChoiceButtons
          options={[
            { label: 'Sim', value: 'Sim' },
            { label: 'Não', value: 'Não' },
          ]}
          selected={data.creditCard || ''}
          onSelect={(value) => handleFieldChange('creditCard', value)}
        />
        {errors.creditCard && (
          <p className="text-red-600 text-sm mt-2">{errors.creditCard}</p>
        )}
      </div>

      <StepNavigation onPrevious={onPrevious} onNext={handleNext} isLoading={isLoading} />
    </StepContainer>
  );
};

export default Step17_Cartao;
